import { render, staticRenderFns } from "./FcWorkHours.vue?vue&type=template&id=0023da36&scoped=true&"
import script from "./FcWorkHours.vue?vue&type=script&lang=js&"
export * from "./FcWorkHours.vue?vue&type=script&lang=js&"
import style0 from "./FcWorkHours.vue?vue&type=style&index=0&id=0023da36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023da36",
  null
  
)

export default component.exports